import { Field } from 'formik';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormikErrorMessage from '../FormikErrorMessage/FormikErrorMessage';
import './FormikSwitch.css';

const FormikSwitch = ({
  name, label, onChange = null, showError = true,
}) => (
  <Field name={name}>
    {({ field }) => (
      <>
        <Form.Check
          type="switch"
          id={name}
          label={label}
          className="form-switch"
          checked={!!field.value}
          {...field}
          {...(onChange && { onChange })}
        />
        {showError && <FormikErrorMessage name={name} />}
      </>
    )}
  </Field>
);

FormikSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
};

export default FormikSwitch;
